import Vue from "vue";
import App from "./App.vue";
import store from "./core/store";
import "./core/registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "./assets/fonts/init.css";
import "./assets/styles/default.css";
import "./assets/styles/effects.css";
import "./lib/metaphone3.js";

import PouchDB from "pouchdb-browser";
import * as pouchVue from "pouch-vue";

PouchDB.plugin(require("pouchdb-find"));
PouchDB.plugin(require("pouchdb-live-find"));
Vue.use(pouchVue, {
	pouch: PouchDB,
	defaultDB: "amos" //LOCAL DB NAME
});

Vue.config.productionTip = false;

new Vue({
	store,
	vuetify,
	render: h => h(App)
}).$mount("#app");
